
export interface DoubleClickHandler {
  onDoubleClick(event: MouseEvent | TouchEvent): unknown;
}

function createTabListener(callback: (event: TouchEvent) => unknown) {
  let lastTap = 0;

  return (event: TouchEvent) => {
    const curTime = new Date().getTime();
    const tapLen = curTime - lastTap;

    if (tapLen < 500 && tapLen > 0) {
      callback(event);
    }

    lastTap = curTime;
  };
}

export class DoubleClickDetector {
  private enabled = true;

  private listener = (event: MouseEvent | TouchEvent) => {
    if (this.enabled) {
      this.handler.onDoubleClick?.(event);
    }
  };

  private tabListener = createTabListener(this.listener);

  constructor(private element: HTMLElement, private handler: Partial<DoubleClickHandler>) {
    this.init();
  }

  public enable() {
    this.enabled = true;
  }

  public disable() {
    this.enabled = false;
  }

  public destroy() {
    this.element.removeEventListener('dblclick', this.listener);
    this.element.removeEventListener('touchend', this.tabListener);
  }

  protected init(): void {
    this.element.addEventListener('dblclick', this.listener);
    this.element.addEventListener('touchend', this.tabListener);
  }
}
